import {WorkspaceTemplate} from '../../../graphql/workspaceTemplates';
import {LinePlotSettings} from '../../WorkspaceDrawer/Settings/types';
import {getXAxisDisplayRow} from './xAxisDisplayValues';

/**
 * We are iteratively adding which fields should be supported in templates.
 * This allows us to remember the areas that we need to handle for the feature.
 */
export const LINE_PLOT_TEMPLATE_FIELDS = ['xAxis'] as const;

export type SupportedLinePlotTemplateField =
  (typeof LINE_PLOT_TEMPLATE_FIELDS)[number];

export type LinePlotDisplayRowFnType = (
  currTemplateLinePlotSettings: WorkspaceTemplate['linePlotSettings'],
  currWorkspaceLinePlotSettings?: LinePlotSettings
) => {
  label: string;
  value: string | undefined;
  newValue?: string;
};

export const LINE_PLOT_TEMPLATE_DISPLAY_FNS: Record<
  SupportedLinePlotTemplateField,
  LinePlotDisplayRowFnType
> = {
  xAxis: getXAxisDisplayRow,
};

/**
 * These are values that should be copied over to the default spec when
 * a template is applied.
 */
export const getLinePlotTemplateValues = (
  workspaceTemplate: WorkspaceTemplate | undefined
): LinePlotSettings => {
  const templateLinePlotSettings = workspaceTemplate?.linePlotSettings;
  if (templateLinePlotSettings == null) {
    return {};
  }

  const workspaceSettings = LINE_PLOT_TEMPLATE_FIELDS.reduce((acc, curr) => {
    acc[curr] = templateLinePlotSettings[curr];
    return acc;
  }, {} as LinePlotSettings);

  return workspaceSettings;
};
